import React, { Component } from 'react';

export default class Icon extends Component {
  render() {
    const { icon, size } = this.props;
    const thisClass = `fas fa-${icon} fa-${size}`
    return (
      <i className={thisClass}></i>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Icon/Icon.js